/**
 * 创建人：王靖
 * 时间：2019-3-11
 * 描述：点击图片的预览的拖拽功能（没有完成。暂时留下)
 * 更新记录: 
 */
import { Directive, HostListener, ElementRef } from '@angular/core';
import { SwPhotoAlbumService } from '../components/basic-components/sw-photo-album/sw-photo-album.service';


/**
 * 图片点击预览大图指令  SwAlbum
 * 
 * @example <img src="../图片地址" SwAlbum>
 */
@Directive({
  selector: '[SwAlbum]'
})
export class SwAlbumDirective {

  /**
   * @ignore
   */
  constructor(private el: ElementRef, public popup: SwPhotoAlbumService) { }

  ngOnInit(): void {
  }


  /**
   * @ignore
   */
  @HostListener('click', ['$event']) onClick(event) {
    if(event.target.src){
      let photosData = {path:[event.target.src],index: 0};
      this.popup.showPhotoAlbum(photosData);
    }
  }
}
